import React from 'react';
import { FileText, CheckCircle } from 'lucide-react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

export const DocumentsSection = ({ fileNames, handleFileChange }) => {
  return (
    <div className="border-l-4 border-orange-600 pl-6">
      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
        <FileText size={24} className="text-orange-700" />
        Documents Requis
      </h3>
      <p className="text-sm text-gray-600 mb-4">Format accepté : JPG, PNG, PDF - Taille max : 5 MB par fichier</p>
      
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="licensePhotoFront" className="text-base font-semibold flex items-center gap-2">
            Permis de conduire - RECTO * 
            <span className="text-sm font-normal text-gray-500">(Photo ou scan)</span>
          </Label>
          <Input
            id="licensePhotoFront"
            name="licensePhotoFront"
            type="file"
            accept="image/*,.pdf"
            onChange={handleFileChange}
            required
            className="h-12 cursor-pointer"
          />
          {fileNames.licensePhotoFront && (
            <p className="text-sm text-green-600 flex items-center gap-2">
              <CheckCircle size={16} />
              {fileNames.licensePhotoFront}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="licensePhotoBack" className="text-base font-semibold flex items-center gap-2">
            Permis de conduire - VERSO *
            <span className="text-sm font-normal text-gray-500">(Photo ou scan)</span>
          </Label>
          <Input
            id="licensePhotoBack"
            name="licensePhotoBack"
            type="file"
            accept="image/*,.pdf"
            onChange={handleFileChange}
            required
            className="h-12 cursor-pointer"
          />
          {fileNames.licensePhotoBack && (
            <p className="text-sm text-green-600 flex items-center gap-2">
              <CheckCircle size={16} />
              {fileNames.licensePhotoBack}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="registrationCardPhoto" className="text-base font-semibold flex items-center gap-2">
            Carte grise du véhicule *
            <span className="text-sm font-normal text-gray-500">(Photo ou scan)</span>
          </Label>
          <Input
            id="registrationCardPhoto"
            name="registrationCardPhoto"
            type="file"
            accept="image/*,.pdf"
            onChange={handleFileChange}
            required
            className="h-12 cursor-pointer"
          />
          {fileNames.registrationCardPhoto && (
            <p className="text-sm text-green-600 flex items-center gap-2">
              <CheckCircle size={16} />
              {fileNames.registrationCardPhoto}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
